module.exports = __webpack_public_path__ + "static/media/after.4d903531.png";